import { render } from "./Bell.vue?vue&type=template&id=1c0a39b6"
import script from "./Bell.vue?vue&type=script&lang=js"
export * from "./Bell.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "1c0a39b6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1c0a39b6', script)) {
    api.reload('1c0a39b6', script)
  }
  
  module.hot.accept("./Bell.vue?vue&type=template&id=1c0a39b6", () => {
    api.rerender('1c0a39b6', render)
  })

}

script.__file = "src/icons/components/filled/Bell.vue"

export default script